module.exports = __webpack_public_path__ + "static/media/noTreeData.2ef77310.png";